export default "__VITE_PUBLIC_ASSET__c1c76c90__"